import { render, staticRenderFns } from "./projectModal.vue?vue&type=template&id=2eb762de&"
import script from "./projectModal.vue?vue&type=script&lang=js&"
export * from "./projectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports